import { type JSX } from "react";
import type { ISvgIcon } from "@/types";

export function ICVi({
  width = "28",
  height = "28",
  className = "",
}: ISvgIcon): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 33 32"
      fill="none"
    >
      <rect x="0.621094" width="32" height="32" rx="16" fill="#F93939" />
      <path
        d="M16.6233 19.9041L12.1646 22.2508L13.0179 17.2865L9.4126 13.7729L14.3961 13.0476L16.6233 8.53345L18.8526 13.0476L23.8339 13.7729L20.2286 17.2865L21.0819 22.2486"
        fill="#FFDA2C"
      />
    </svg>
  );
}
